"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsListElement = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var React = __importStar(require("react"));
var Divider_1 = require("../Divider");
var FieldFormatter_1 = require("../FieldFormatter");
var FlexView_1 = require("../FlexView");
var Image_1 = require("../Image");
var Spacer_1 = require("../Spacer");
var TextFormatter_1 = require("../TextFormatter");
require("./notificationsListElement.css");
var NotificationsListElement = /** @class */ (function (_super) {
    __extends(NotificationsListElement, _super);
    function NotificationsListElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationsListElement.prototype.buildDate = function () {
        return (0, function_1.pipe)(O.fromNullable(this.props.date), (0, Option_1.map)(function (date) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 2, style: { textAlign: 'center' } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "notify-icon-date" }, { children: (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ fontSize: "sm" }, { children: (0, moment_timezone_1.default)().format('DMY') === (0, moment_timezone_1.default)(date).format('DMY') ? ((0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Date, { date: date, format: "HH:mm" })) : ((0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Date, { date: date, format: "D MMM" })) })) })) }))); }), O.toNullable);
    };
    NotificationsListElement.prototype.renderSubTitle = function () {
        var _this = this;
        return (0, function_1.pipe)(O.fromNullable(this.props.subTitle), (0, Option_1.map)(function (subTitle) { return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.7 }), (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ fontWeight: _this.props.read ? 'std' : 'bold', fontSize: "sm", borderless: true }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "notify-icon-list-element-content" }, { children: subTitle.replace(/<(?:.|\n)*?>/gm, '').replace('&nbsp;', '') })) }))] })); }), O.toNullable);
    };
    NotificationsListElement.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('notify-icon-list-element', this.props.read ? '' : 'notify-icon-list-element-orange', this.props.onClick ? 'notify-icon-list-element-clickable' : ''), onClick: function () { return _this.props.onClick && _this.props.onClick(_this.props.id); } }, { children: [(0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.8 }), (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ vAlignContent: "center", hAlignContent: "between", gutters: { lr: 'mi' } }, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 3 }, { children: (0, jsx_runtime_1.jsx)(Image_1.Image, { size: "sm", circular: true, border: true, src: this.props.image }) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: !this.props.date ? 9 : 7, style: { textAlign: 'left' } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "notify-icon-content-central-text" }, { children: [(0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ fontWeight: this.props.read ? 'std' : 'bold', fontSize: "std-plus", borderless: true }, { children: this.props.title })), this.renderSubTitle()] })) })), this.buildDate()] })), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.5 }), (0, jsx_runtime_1.jsx)(Divider_1.Divider, { orientation: "horizontal", margin: "none" })] })));
    };
    return NotificationsListElement;
}(React.PureComponent));
exports.NotificationsListElement = NotificationsListElement;
//# sourceMappingURL=NotificationsListElement.js.map